module.exports = __webpack_public_path__ + "static/media/15.c2f6342e.jpg";